<template>
    <div class="web-auth-card">
        <div class="web-auth-card__header">
            <div class="text-right">
                <ui-button 
                    variant="secondary" 
                    @click="$refs.deviceList.addDevice()" 
                    :disabled="disabled || isSaving"
                    :loading="isSaving"
                >
                    {{ $t('Add') }}
                    <span class="fas fa-plus" v-if="!isSaving"></span>
                </ui-button>
            </div>
            <div class="web-auth-card__content">
                <div class="web-auth-card__icon">
                    <span class="fas fa-fingerprint"></span>
                </div>
                <div class="web-auth-card__text-container">
                    <h6 class="mb-0">{{ $t('Pass Keys Authentication') }}</h6>
                    <p class="mb-0">{{ $t('Add an extra layer of security to your account by requesting access with pass key authentication for an extra layer of security.') }}</p>
                    <p class="mb-0 text-muted" v-if="!isAvailable"> {{ $t(`${message}`) }}</p>
                </div>
            </div>
        </div>
        <div class="web-auth-card__content">
            <device-list ref="deviceList" class="web-auth-card__device-list" @saving-changed="handleSavingChanged"/>
        </div>
    </div>
</template>

<script>
import UiButton from '@/components/ui/buttons/Button.vue';
import DeviceList from '@/components/authentication/webauthn/DeviceList.vue';
export default {
    name: 'WebAuthnCard',
    components: { DeviceList, UiButton },
    data() {
        return {
            disabled: false,
            isAvailable: false,
            message: null,
            isSaving: false,
        };
    },
    async mounted() {
        await this.checkPasskeySupport();
    },
    methods: {
        handleSavingChanged(isSaving) {
            this.isSaving = isSaving;
        },
        async checkPasskeySupport() {
            if (window.PublicKeyCredential) {
                const isPlatformAuthenticatorAvailable = await PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
                if (isPlatformAuthenticatorAvailable) {
                    this.isAvailable = true;
                    this.disabled = false;
                } else {
                    this.isAvailable = false;
                    this.message = 'Authentication available, but you need to enable biometric or security authentication on your device.';
                    this.disabled = true;
                }
            } else {
                this.disabled = true;
                this.message = 'Authentication not supported on this device.';
            }
        },
    },
};
</script>

<style lang="scss">
.web-auth-card {
    align-items: center;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;

    &__header {
        display: flex;
        flex-direction: column;
        gap: 16px;
        justify-content: space-between;
        width: 100%;

        @media (min-width: 768px) {
            flex-direction: row-reverse;
            gap: 32px;
        }
    }

    &__content {
        display: flex;
        gap: 8px;
        width: 100%;
    }

    &__icon {
        align-items: center;
        background-color: var(--color-accent-base);
        border-radius: 8px;
        color: $white;
        display: flex;
        flex-shrink: 0;
        font-size: 1rem;
        height: 30px;
        justify-content: center;
        width: 30px;

        @media (min-width: 768px) {
            height: 50px;
            width: 50px;
            font-size: 1.375rem;
        }
    }

    &__empty-message {
        background-color: #eff1f8;
        border-radius: 8px;
        padding: 16px;
        text-align: center;
        width: 100%;
        margin-bottom: 0;
    }

    &__device-list {
        border-radius: 8px;
        padding: 16px;
        text-align: center;
        width: 100%;
        margin-bottom: 0;
    }
}
</style>
